import moment from 'moment';
import {configuredDate, sortCollectionDatesAsc} from '../utils/personalization';
import {getUsername} from '../../../_shared/GWTBridge/invoke/genPage';

interface CollectionDate {
    date: string;
    id?: number;
    neverShowAgain: boolean;
    formName: string;
    user: string;
}

export const getLastCollectionDates = async (db, formName: string) => {
    const collectionArray: CollectionDate[] = await db.collectionDates
        .where('[formName+user]')
        .equals([formName, getUsername()])
        .toArray();

    collectionArray.sort((a: CollectionDate, b: CollectionDate) => {
        const date1 = a?.date?.split('/').reverse().join('');
        const date2 = b?.date?.split('/').reverse().join('');
        return date1 > date2 ? 1 : date1 < date2 ? -1 : 0;
    });

    return collectionArray?.pop();
};

export const getPrevCollectionDate = async (db, formName: string) => {
    const collectionArray: CollectionDate[] = await db.collectionDates
        .where('[formName+user]')
        .equals([formName, getUsername()])
        .toArray();
    if (collectionArray.length > 1) {
        const sortedDates = sortCollectionDatesAsc(collectionArray);
        return sortedDates[sortedDates.length - 2];
    }
};

export const getLastUserCollectionDates = async (db, userName: string) => {
    const collectionArray: CollectionDate[] = await db.collectionDates
        .where('user')
        .equals(userName)
        .toArray();

    collectionArray.sort((a: CollectionDate, b: CollectionDate) => {
        const date1 = a?.date?.split('/').reverse().join('');
        const date2 = b?.date?.split('/').reverse().join('');
        return date1 > date2 ? 1 : date1 < date2 ? -1 : 0;
    });

    return collectionArray?.pop();
};

export const getPrevUserCollectionDate = async (db, userName: string) => {
    const collectionArray: CollectionDate[] = await db.collectionDates
        .where('user')
        .equals(userName)
        .toArray();
    if (collectionArray.length > 1) {
        const sortedDates = sortCollectionDatesAsc(collectionArray);
        return sortedDates[sortedDates.length - 2];
    }
};

export const startNewCollection = async (db, formName: string, configuration) => {
    const userName = getUsername();
    let date = configuredDate().format('DD/MM/YYYY'); // will use if has no collaction date (first entry)

    await db.transaction('rw', db.collectionDates, async () => {
        // get last collactionDate from random form

        const lastCollactionAll = await getLastUserCollectionDates(db, userName);

        if (
            lastCollactionAll?.date &&
            configuredDate().diff(moment(lastCollactionAll?.date, 'DD/MM/YYYY'), 'days') <
                configuration.days
        ) {
            date = lastCollactionAll?.date;
        }

        db.collectionDates
            .add({date, user: getUsername(), formName, neverShowAgain: false})
            .catch(e => console.log('error adding new collection', e));
    });

    return date;
};

export const removeNeverShowAgainIndexedDB = db => {
    db.transaction('rw', db.collectionDates, db.blackList, async () => {
        db.collectionDates
            .where('user')
            .equals(getUsername())
            .modify(cd => {
                cd.neverShowAgain = false;
            });
        db.blackList.clear();
    }).catch(e => console.log('indexedDB neverShowAgain error: ', e));
};

export const setNeverShowAgainIndexedDB = db => {
    db.transaction('rw', db.collectionDates, async () => {
        db.collectionDates
            .where('user')
            .equals(getUsername())
            .modify(cd => {
                cd.neverShowAgain = true;
            });
    }).catch(e => console.log('indexedDB neverShowAgain error: ', e));
};

export const addToBlackList = (formName: string, db: any, type?: string) => {
    db.transaction('rw', db.blackList, async () => {
        if (type) {
            db.blackList.add({name: formName, user: getUsername(), type: type});
        } else {
            db.blackList.add({name: formName, user: getUsername()});
        }
    }).catch(e => console.log('indexedDB add to blacklist error: ', e));
};
